module.exports = __webpack_public_path__ + "media/images/icons/smile-7982476e04427827a9261d6661a998b8.svg";